import React from 'react'
import AutoComplete from './AutoComplete'
import Multiple from './Multiple'

export default React.memo((props) => {

    const onChange = (data, name, e) => {
        props.onChange(data, props.name, e)
    }
    return (
        props.multiple &&
        <Multiple
            autocomplete={props.autocomplete}
            placeholder={props.placeholder}
            autoFocus={props.autoFocus}
            inputProps={props.inputProps || {}}
            InputProps={props.InputProps || {}}
            name={props.name}
            className={props.className}
            inputStyle={props.inputStyle || {}}
            inline={props.inline}
            disabled={props.disabled || false}
            MenuProps={props.MenuProps || {}}
            title={props.title}
            onChange={onChange}
            classes={props.classes}
            style={Object.assign({ width: '100%', padding: 0 }, props.style || {})}
            options={props.options}
            value={props.value !== undefined ? Array.isArray(props.value) && props.value || [props.value] : props.default} />
        ||
        <AutoComplete
            autocomplete={props.autocomplete}
            classNameModal={props.classNameModal}
            placeholder={props.placeholder}
            autoFocus={props.autoFocus}
            name={props.name}
            autoComplete={props.autoComplete !== false}
            inputProps={props.inputProps || {}}
            InputProps={props.InputProps || {}}
            menuMaxHeight={props.menuMaxHeight}
            MenuProps={props.MenuProps || {}}
            loading={props.loading}
            className={props.className}
            variant={props.variant}
            classes={props.classes}
            onChangeText={props.onChangeText}
            value={props.text}
            nameText={props.nameText}
            add={props.add}
            selectedTextClassName={props.selectedTextClassName}
            inputStyle={props.inputStyle || {}}
            inline={props.inline}
            disabled={props.disabled || false}
            title={props.title}
            onChange={onChange}
            style={{ width: '100%', padding: 0, ...(props.style || {}) }}
            options={props.options}
            data={props.value !== undefined ? props.value : props.default} />
    )
})



// WEBPACK FOOTER //
// ./app/Components/Select.js